import React from "react";
import Modal, { ModalTransition } from "@atlaskit/modal-dialog";
import apiClient from "../../api/api-client";
import { toast } from "react-toastify";
import useAsync from "../../hooks/use-async";

export default function RemoveFilter({ filter, onRemoved, onClose, documentTypeId }) {
    const { run, isPending } = useAsync();
    const remove = () => {
        run(apiClient(`document-type/${documentTypeId}/filters/${filter.id}`, { method: "DELETE"}))
            .then(() => {
                toast.success("Filtr został usunięty");
                onRemoved && onRemoved();
            })
            .catch(error => toast.error("Nie udało się usunąć filtru: " +  error.message));
    };

    return (
        <>
            <ModalTransition>
                <Modal
                    isLoading={isPending}
                    actions={[
                        { text: "Usuń", onClick: remove },
                        { text: "Anuluj", onClick: onClose },
                    ]}
                    onClose={close}
                    heading="Czy chcesz usunąć ten filtr?"
                    appearance="danger"
                >
                    <p>
                        Tej czynności nie można cofnąć.
                    </p>
                </Modal>
            </ModalTransition>
        </>
    );
}